<template>
    <div class="dropdown" v-if="this.bids.length">
        <a class="dropdownBTN w-100" href="#" role="button" :id="idObject" data-toggle="dropdown">
            Gebote: {{ this.bids.length }}
        </a>
        <div class="dropdown-menu" :aria-labelledby="idObject">
            <div class="dropdown-item" v-for="(bid, index) in bids" :key="index">
                <div class="price">{{ bid.buyingPrice }} €</div><div class="datetime">{{ bid.validFrom }} {{ bid.validFromTime }}</div>
            </div>
        </div>
    </div>
    <div class="dropdown" v-else>
        <a class="dropdownBTN noBids w-100">
            Gebote: {{ this.bids.length }}
        </a>
    </div>
</template>

<script>

    export default {
        props: {
            productid: {
                type: [Number,String],
                default: ''
            },
        },

        data () { 
            return {
               highestbid: 0,
               bids: []
            }
        },

        mounted: function() {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.productid == data.productId) {
                    this.bids.unshift(
                        {
                            "buyingPrice": data.bid,
                            "validFrom": data.date,
                            "validFromTime": data.time
                        }
                    );
                }  
            });
        },

        created () {
            new Form({id: this.productid}).post('/api/bids').then((response) => {
                this.bids = response;
            });
        },
        computed: {
            idObject: function () {
                return 'bids' + this.productid;
            }
        }
    }
</script>
